export interface IUserGroupUserSaveSuccess {
    message: string;
    refreshSessionState: boolean;
}

export class UserGroupUserSaveSuccess implements IUserGroupUserSaveSuccess {
    message: string;
    refreshSessionState: boolean;

    constructor();
    constructor(obj: IUserGroupUserSaveSuccess);
    constructor(obj?: any) {
        this.message = obj && obj.message || "";
        this.refreshSessionState = obj && obj.refreshSessionState || false;
    }
}